/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

/* eslint-disable @typescript-eslint/no-floating-promises */
import { PureComponent } from 'react';
import { Metrics } from '../utils/Metrics';
// @ts-expect-error not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import PropTypes from 'prop-types';
import { OrderedMap } from 'immutable';
import AsyncData from 'conversations-async-data/async-data/AsyncData';
import { UNINITIALIZED } from 'conversations-async-data/async-data/constants/asyncStatuses';
import { isUninitialized } from 'conversations-async-data/async-data/operators/statusComparators';
import { requestStarted } from 'conversations-async-data/async-data/operators/requestStarted';
import { requestFailed } from 'conversations-async-data/async-data/operators/requestFailed';
import { requestOutOfSync } from 'conversations-async-data/async-data/operators/requestOutOfSync';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { requestSucceededWithOperator } from 'conversations-async-data/async-data/operators/requestSucceededWithOperator';
import { logNetworkError } from 'calling-lifecycle-internal/utils/logNetworkError';
import CallMetadata from '../call-message/records/CallMessage';
import { getMessageDirection } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getShouldRefetchCallMessage, getTimestamp, getCRMObjectId, getIsCallInProgress, getResult, getHasRecording, getIsRecordingDeleted, getRecordingUrl } from '../call-message/operators/callMessageGetters';
import { callingAPIMethodWithQueue } from 'calling-global-api/utils/hsCallingUtils';
import { getCallMetadata } from '../clients/getCallMetadata';
import { ON_CALL_SAVED } from 'calling-global-api/constants/EventListeners';
import { deleteRecording } from '../clients/deleteRecording';
// @ts-expect-error not typed

// @ts-expect-error not typed

import { logPageAction } from 'calling-error-reporting/report/error';
import { jsx as _jsx } from "react/jsx-runtime";
export function withCallMessage(Component) {
  let cachedCallMessage = OrderedMap();
  const cacheCallMessageChange = ({
    callId,
    callMessage
  }) => {
    cachedCallMessage = cachedCallMessage.set(callId, callMessage);
  };
  const getInitialCachedCallMessage = callId => {
    let asyncCallMessage = cachedCallMessage.get(callId);
    if (!asyncCallMessage) {
      asyncCallMessage = new AsyncData({
        status: UNINITIALIZED
      });
      cacheCallMessageChange({
        callId,
        callMessage: asyncCallMessage
      });
    }
    return asyncCallMessage;
  };
  class CallMessageWrapper extends PureComponent {
    constructor(props) {
      super(props);
      this.handleFetchCallMessageResponse = ({
        response,
        error
      }) => {
        const {
          callId
        } = this.props;
        const {
          asyncCallMessage
        } = this.state;
        const callMessage = error ? requestFailed(asyncCallMessage) : requestSucceededWithOperator(() => new CallMetadata(response), asyncCallMessage);
        cacheCallMessageChange({
          callId,
          callMessage
        });
        if (this.mounted) {
          this.setState({
            asyncCallMessage: callMessage
          });
        }
        return response;
      };
      this.handleResetAndFetchCallMessage = () => {
        this.setState({
          asyncCallMessage: new AsyncData({
            status: UNINITIALIZED
          })
        }, () => this.handleFetchCallMessage());
      };
      this.MAX_CALL_STATUS_POLL_ATTEMPTS = 120;
      this.pollUntilCallCompleted = (retryCount = 0) => {
        this.fetchCallMessage().then(response => {
          // retries every 30s up to an hour, then bails
          if (retryCount < this.MAX_CALL_STATUS_POLL_ATTEMPTS && getIsCallInProgress(response)) {
            this._callStatusPollTimeout = setTimeout(() => this.pollUntilCallCompleted(retryCount + 1), 30000);
          } else {
            this._handleCallCompleted(retryCount);
          }
        }).catch(e => {
          logNetworkError({
            networkError: e,
            error: new Error('Error fetching call message for call status polling')
          });
        });
      };
      this._handleCallCompleted = retryCount => {
        clearTimeout(this._callStatusPollTimeout);
        logPageAction({
          key: 'INBOX_CALL_STATUS_POLLING_COMPLETED',
          tags: {
            retryCount
          }
        });
        Metrics.counter('call_status_polling_completed', {
          retryCount: retryCount.toString()
        }).increment();
      };
      this.handlePostCallPolling = () => {
        const {
          callId
        } = this.props;
        const {
          asyncCallMessage
        } = this.state;
        const callMessageData = getData(asyncCallMessage);
        if (getShouldRefetchCallMessage(callMessageData) && !this._postCallPollTimeout) {
          const callMessage = requestOutOfSync(asyncCallMessage);
          cacheCallMessageChange({
            callId,
            callMessage
          });
          this.setState({
            asyncCallMessage: callMessage
          }, () => this.refetchAndPollCalleeDetails());
        }
      };
      this.MAX_POLL_ATTEMPTS = 90;
      this.refetchAndPollCalleeDetails = (retryCount = 0) => {
        if (retryCount === this.MAX_POLL_ATTEMPTS) {
          this.maxPollAttemptsReached = true;
        }
        this.fetchCallMessage().then(response => {
          // retries for 3 minutes then bails.
          if (retryCount < this.MAX_POLL_ATTEMPTS && getShouldRefetchCallMessage(response)) {
            this._postCallPollTimeout = setTimeout(() => this.refetchAndPollCalleeDetails(retryCount + 1), 2000);
          } else {
            this._handlePostCallPollingCompleted(retryCount);
          }
        }).catch(e => {
          logNetworkError({
            networkError: e,
            error: new Error('Error fetching call message for call recording polling')
          });
        });
      };
      this._handlePostCallPollingCompleted = retryCount => {
        const {
          asyncCallMessage
        } = this.state;
        const callMessageData = getData(asyncCallMessage);
        const hasRecording = getResult(getHasRecording(callMessageData));
        const isRecordingDeleted = getResult(getIsRecordingDeleted(callMessageData));
        const recordingUrl = getResult(getRecordingUrl(callMessageData));
        logPageAction({
          key: 'WORKSPACE_POST_CALL_POLLING_COMPLETED',
          tags: {
            hasRecording,
            isRecordingDeleted,
            recordingUrl,
            retryCount
          }
        });
        Metrics.counter('workspace_post_call_polling_completed', {
          retryCount: retryCount.toString()
        }).increment();
      };
      this.handleDeleteRecording = engagementId => {
        const {
          asyncCallMessage
        } = this.state;
        const callMessageData = getData(asyncCallMessage);
        deleteRecording(engagementId).then(() => {
          if (getCRMObjectId(callMessageData) === engagementId) {
            this.fetchCallMessage();
          }
        }).catch(e => {
          logNetworkError({
            networkError: e,
            error: new Error('Error deleting call recording')
          });
        });
      };
      this.state = {
        asyncCallMessage: getInitialCachedCallMessage(props.callId)
      };
      this.mounted = false;
      this.maxPollAttemptsReached = false;
      this._callStatusPollTimeout = undefined;
      this._postCallPollTimeout = undefined;
      this._recordingPollTimeout = undefined;
    }
    componentDidMount() {
      this.mounted = true;
      this.handleEngagementDataUpdated = this.handleEngagementDataUpdated.bind(this);
      const {
        asyncCallMessage
      } = this.state;
      if (isUninitialized(asyncCallMessage)) {
        // only cache 25 call details at a time, if the 25th detail unmounts it will refetch.
        if (cachedCallMessage.size > 24) {
          cachedCallMessage = cachedCallMessage.rest();
        }
        this.handleFetchCallMessage();
      }
      callingAPIMethodWithQueue('addEventListener', {
        event: ON_CALL_SAVED,
        callback: this.handleEngagementDataUpdated
      });
    }
    componentDidUpdate(prevProps) {
      const {
        message
      } = this.props;
      const currentTimestamp = getTimestamp(message);
      const previousTimestamp = getTimestamp(prevProps.message);
      if (currentTimestamp !== previousTimestamp) {
        this.fetchCallMessage();
      }
    }
    componentWillUnmount() {
      this.mounted = false;
      clearTimeout(this._callStatusPollTimeout);
      clearTimeout(this._postCallPollTimeout);
      clearTimeout(this._recordingPollTimeout);
      callingAPIMethodWithQueue('removeEventListener', {
        event: ON_CALL_SAVED,
        callback: this.handleEngagementDataUpdated
      });
    }
    handleEngagementDataUpdated({
      engagementId
    }) {
      const {
        asyncCallMessage
      } = this.state;
      const callMessageData = getData(asyncCallMessage);
      if (getCRMObjectId(callMessageData) === engagementId) {
        this.fetchCallMessage();
      }
    }
    fetchCallMessage() {
      const {
        callId
      } = this.props;
      return getCallMetadata({
        callId
      })
      // @ts-expect-error todo: figure out
      .then(this.handleFetchCallMessageResponse).catch(networkError => {
        logNetworkError({
          networkError,
          error: new Error('Unable to parse call details'),
          extraData: {
            callId
          }
        });
      });
    }
    handleFetchCallMessage() {
      const {
        callId
      } = this.props;
      const {
        asyncCallMessage
      } = this.state;
      const callMessage = requestStarted(asyncCallMessage);
      cacheCallMessageChange({
        callId,
        callMessage
      });
      this.setState({
        asyncCallMessage: callMessage
      }, () => this.fetchCallMessage());
    }
    render() {
      const {
        message,
        ungatedForNextBestActions,
        ungatedForCopilotPreview,
        ungatedForChatspot,
        ungatedForAutogenerateCopilotCallSummary,
        ungatedForOmnichannelCallSummaryAiSkill
      } = this.props;
      const {
        asyncCallMessage
      } = this.state;
      const timestamp = getTimestamp(message);
      const direction = getMessageDirection(message);
      return /*#__PURE__*/_jsx(Component, {
        handleEngagementDataUpdated: this.handleEngagementDataUpdated,
        handlePostCallPolling: this.handlePostCallPolling,
        maxPollAttemptsReached: this.maxPollAttemptsReached,
        pollUntilCallCompleted: this.pollUntilCallCompleted,
        resetCallMessage: this.handleResetAndFetchCallMessage,
        asyncCallMessage: asyncCallMessage,
        onDeleteRecording: this.handleDeleteRecording,
        timestamp: timestamp,
        direction: direction,
        message: message,
        ungatedForCopilotPreview: ungatedForCopilotPreview,
        ungatedForNextBestActions: ungatedForNextBestActions,
        ungatedForChatspot: ungatedForChatspot,
        ungatedForAutogenerateCopilotCallSummary: ungatedForAutogenerateCopilotCallSummary,
        ungatedForOmnichannelCallSummaryAiSkill: ungatedForOmnichannelCallSummaryAiSkill
      });
    }
  }
  CallMessageWrapper.propTypes = {
    callId: PropTypes.number.isRequired,
    message: RecordPropType('CommonMessage').isRequired,
    callMetadata: RecordPropType('CallMetadata').isRequired
  };
  return CallMessageWrapper;
}